// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zoom-enter-active[data-v-905c6f06],.zoom-leave-active[data-v-905c6f06]{transition:all .2s ease}.zoom-enter[data-v-905c6f06],.zoom-leave-to[data-v-905c6f06]{transform:scale(0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
